import { useEffect,useState } from 'react';
import { Moon,Sun } from 'lucide-react';
import { configureUiPreferences,resolveTheme,subscribeTheme,writeUiPreferences } from '@realrain/ui/preferences';

// Platform Admin shares the theme preference with every product but may only
// connect to itself (connect-src 'self'). A choice made here reaches the
// account the next time a product or Account page aligns this browser.
configureUiPreferences({accountSync:false});

export function ConsoleTheme() {
  const [theme,setTheme]=useState<'light'|'dark'>(()=>resolveTheme());
  useEffect(()=>subscribeTheme(setTheme),[]);
  useEffect(()=>{document.documentElement.dataset.theme=theme;document.documentElement.classList.toggle('dark',theme==='dark');window.dispatchEvent(new CustomEvent('realrain:admin-theme',{detail:theme}));},[theme]);
  return <button className="header-logout" aria-label={theme==='light'?'切换为深色':'切换为浅色'} onClick={()=>writeUiPreferences({theme:theme==='light'?'dark':'light'})}>{theme==='light'?<Moon size={16}/>:<Sun size={16}/>}</button>;
}
